/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */
import React from 'react';

import { Checkbox } from 'carbon-components-react';


function CarbonCheckboxWidget(props) {
    const {
        id,
        value,
        disabled,
        readonly,
        label,
        options,
    } = props;
    // Because an unchecked checkbox will cause html5 validation to fail, only add
    // the "required" attribute if the field value must be "true", due to the
    // "const" or "enum" keywords
    const required = undefined;

    // the onChange function called by Carbon's Checkbox has the value as first parameter
    const _onChange = (value) => {
        props.onChange(value === '' ? options.emptyValue : value);
    };

    return (
        <Checkbox
            checked={typeof value === 'undefined' ? false : value}
            required={required}
            labelText={label}
            disabled={disabled || readonly}
            hideLabel={false}
            onChange={_onChange}
            id={id}
        />
    );
}

CarbonCheckboxWidget.defaultProps = {
    autofocus: false,
    value: false,
    options: { 'emptyValue': undefined }
};

export { CarbonCheckboxWidget };
